import RefundTerms from '@v2/brands/topmags/components/RefundTerms';
import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /refund.
 *
 * The terms are `RefundTerms`, which the FAQ's last answer renders as well: this brand
 * publishes them twice and they have to say the same thing both times.
 *
 * The last of this brand's institutional pages to move. #1814 converted the other six and
 * left this one on `layouts/full_responsive.html`, so it was the one entry in the rail
 * whose page did not itself keep the rail.
 */
export default function RefundPolicy() {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Refund Policy' }]} />

      <PageHeading eyebrow="Customer Information">Refund Policy</PageHeading>

      <ContentCard className="prose mt-6">
        <RefundTerms />
      </ContentCard>
    </>
  );
}

RefundPolicy.layoutName = 'Layouts.Institutional';
